import { environment } from '../../../../environments/environment';

/**
 * Appels du moteur IA et de la délivrance de son jeton.
 *
 * Ces appels ne portent jamais l'identité Engage (Authorization) du
 * navigateur vers le moteur : le moteur n'accepte que son propre jeton, lié à un
 * test (voir `AiExamService`). Un 401/403 de ces appels dit « jeton refusé » ou
 * « test non accessible » et non « session Engage expirée » : il ne doit pas
 * déconnecter l'utilisateur, `AiExamService` redemande lui-même un jeton une fois.
 */

/** Vrai si l'URL vise le moteur IA (`environment.aiServer`). */
export function isAiEngineUrl(url: string): boolean {
    return !!environment.aiServer && !!url && url.includes(environment.aiServer);
}

/** Vrai si l'URL est la délivrance du jeton du moteur par Engage (`POST ai/token/`). */
export function isAiTokenUrl(url: string): boolean {
    return !!url && url.includes(environment.server + 'ai/token/');
}

/** Un refus de ces appels (401/403) n'est pas une fin de session Engage. */
export function isAiAccessRequest(url: string): boolean {
    return isAiEngineUrl(url) || isAiTokenUrl(url);
}

/** Motif de refus de `ai/token/` : le candidat FlashLevel n'a pas vérifié de code OTP pour ce test. */
export const AI_TOKEN_REFUSAL_OTP_NOT_VERIFIED = 'otp_not_verified';

/**
 * Vrai si l'erreur est le refus de `ai/token/` faute d'OTP vérifié (403 + `refusal_reason`).
 * C'est le cas d'un FlashLevel passé avant l'OTP : le candidat vérifie un code, puis lit ses résultats.
 */
export function isOtpNotVerifiedRefusal(err: { status?: number; error?: { refusal_reason?: string } } | null | undefined): boolean {
    return err?.status === 403 && err?.error?.refusal_reason === AI_TOKEN_REFUSAL_OTP_NOT_VERIFIED;
}
